import CardsList from "@/components/cardsList";
import { SOLUTIONS_CONSTANTS } from "./constants";

const Solutions = () => {
  return <CardsList {...SOLUTIONS_CONSTANTS} />;
};

export default Solutions;
